/**
 * plugins/vuetify.js
 *
 * Framework documentation: https://vuetifyjs.com`
 */

/* eslint-disable import/no-unresolved */
// Styles
//
// `vuetify/styles` is intentionally NOT imported here. It is instead
// imported from `src/assets/styles/tailwind.css` with `layer(vendor)`
// so Vuetify's unlayered button/input/etc. resets stop overriding our
// Tailwind utilities. See the comment in tailwind.css.

// Composables
import { createVuetify } from 'vuetify';

// Colors
import colors from 'vuetify/util/colors';

// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
export default createVuetify({
  theme: {
    themes: {
      light: {
        colors: {
          primary: colors.teal.lighten2,
          secondary: colors.grey.lighten5,
          background: colors.grey.lighten5,
        },
      },
    },
  },
});
